export default {
  reportMetadata: {
    titles: {
      360: 'The report',
      '360-compare': 'Team report based on the assessment 360 results',
      self: 'The report',
      team: 'The report',
      'ht-personal': 'The report',
      'bh-personal-user': 'Personal testing',
      'bh-personal-team': 'Summary report on the personal qualities of the team members',
    },
    exportTitles: {
      360: 'Report 360',
      '360-compare': 'Team report 360',
      self: 'Self-assessment report',
      team: 'Team report 360',
      'ht-personal': 'Personal report',
      'bh-personal-user': 'Personal report',
      'bh-personal-team': 'Summary personal report',
    },
    shareReportTitle: 'Share a link to the report',
    withoutCalc: 'without calculations',
    differenceScoresLegend: {
      labels: {
        less: 'The difference is less than or equal to',
        more: 'The difference is more than',
      },
    },
    scoresLegend: {
      labels: {
        low: 'Below normal',
        middle: 'Meets normal',
        high: 'Above normal',
      },
    },
    deviationLegend: {
      labels: {
        low: 'below average in&nbsp;specialization',
        middle: 'matches average in&nbsp;specialization',
        high: 'above average in&nbsp;specialization',
      },
    },
    potentialMatrix: {
      labels: {
        area: {
          underestimated: 'Latent potential',
          strengths: 'The backbone of the team',
          growthAreas: 'Development area',
          overestimated: 'The risk of self-assessment',
        },
        axis: {
          top: 'All without self-assessment',
          bottom: 'All without self-assessment',
          left: 'Low self-assessment',
          right: 'High self-assessment',
        },
      },
      tooltips: {
        area: {
          underestimated:
            "Employees with pronounced strengths that they don't realize. Support and recognition will help them unlock their potential. At the top of the list are the participants with the greatest discrepancy between external assessment and self—assessment.",
          strengths:
            'Employees whose strengths are recognized by all. Potential mentors and leaders. At the top of the list are the participants with the highest ratings of colleagues and at the same time high self-assessment.',
          growthAreas:
            'Employees who need support and development. Training, mentoring, and motivation enhancement programs are recommended. At the top of the list are the employees who show the lowest scores in terms of self-assessment and external perception.',
          overestimated:
            'Overestimated self-assessment relative to the opinions of other participants in the assessment. The basis for feedback and development of soft skills. At the top of the list are the participants with the largest difference between self-assessment and external assessment.',
        },
      },
      noData: 'None of the employees got into this area',
    },
    teamList: {
      title: 'The composition of the team',
      table: {
        headers: {
          name: 'Name',
        },
      },
    },
    stubs: {
      noScore: 'no score',
      noScores: 'no scores',
    },
    errorMessages: {
      uploadDiagram: 'Failed to upload some charts! The report will be generated without them',
      getReportParams: 'Failed to get params of the report',
    },
    360: {
      totalSection: {
        title: 'Total for the section',
      },
      changeCommentsParamsDialog: {
        title: 'Configure the comments',
        subtitle: 'The settings will be saved for all versions of this report.',
        labels: {
          hideAll: 'Disable the visibility of all comments',
          onlySupervisor: "Leave only the supervisor's comments visible",
          colleagues: 'Disable visibility from colleagues',
        },
        successMessage: 'The comments settings successfully saved',
        errorMessage: 'Failed to save the comments settings',
      },
      changeVisibleExpertGroupsDialog: {
        title: 'Configure the expert groups',
        subtitle:
          'The settings will affect the display of expert groups in the table and in the overall results diagram. When uploading to PDF and DOC, only active expert groups will be uploaded.',
        successMessage: 'The expert groups settings successfully saved',
        errorMessage: 'Failed to save the experts groups settings',
      },
      changeFiltersDialog: {
        title: 'Configure the report',
        subtitle: 'Select the report parameters',
        labels: {
          skillsTypes: 'Assessed skills',
          targetFields: 'Factored-in assessments',
        },
      },
      user: {
        adequacySelf: {
          title: "Is the employee's self-assessment adequate",
          table: {
            legendLabels: {
              differenceScores:
                'The scale shows the difference between the self-assessment and the assessment of the other participants',
            },
          },
        },
        compareSelfOther: {
          title:
            "Comparing the employee's self-assessment with the assessments of other participants",
          groupFeedback: {
            title: 'Strengths and growth areas according to individual groups of participants',
          },
          johari: {
            title: 'Assessment results in the Johari Window view',
          },
        },
        compareSupervisorOther: {
          title: "Does the supervisor's assessment match the opinion of other participants",
          table: {
            legendLabels: {
              differenceScores:
                "The scale shows the difference between the supervisor's assessment and the assessment of the other participants",
            },
          },
        },
        recommend: {
          title: 'Development recommendations',
          table: {
            noData: 'Not a single competence fell into this category',
          },
        },
        results: {
          title: 'Overall results',
          table: {
            legendLabels: {
              scores:
                'The scale of scores for everyone without self-assessment (the color of the numbers in the tables corresponds to the scale)',
              importance: 'Importance values',
            },
          },
        },
      },
      compare: {
        info: {
          title: 'Team report based on the assessment 360 results',
          labels: {
            creationDate: 'Creation date the report',
            evalPeriod: 'Evaluation period',
          },
        },
        potentialMatrix: {
          title: 'The matrix of development and potential',
          description:
            "<p>Comparison of the employee's self-assessment with other evaluation participants.</br>The matrix helps identify potential mentors and leaders, employees with hidden potential, and those who need support and development.</p>",
          headers: {
            self: 'Self-assessment',
            experts: 'All without self-assessment',
            diff: 'Difference',
          },
        },
        skippedScores: {
          title: 'Skipped scores',
          description:
            '<p>Indicators that respondents most often did not evaluate. A high percentage of n/a indicates that the indicator is difficult to evaluate or is irrelevant. This helps to identify indicators that need to be revised or clarified in order to improve the quality of the assessment.</p>',
        },
        averageScore: {
          title: 'Average score by specialization',
          description:
            '<p>Comparison of the average score of an employee with the average score of all employees selected for the analysis by specialization.<br />It allows you to identify employees who are above or below the average level in specialization in order to plan a training and development strategy and form a personnel reserve.</p>',
          table: {
            headers: {
              deviation: 'Deviation',
              averageScore: 'Average score',
            },
          },
          legends: {
            labels: {
              scores: 'The scale of scores',
              deviation: 'The scale of deviation',
            },
            tooltips: {
              scores:
                "The color of the employee's average score in the diagram below corresponds to the colors of this scale.",
              deviation:
                'The color of the numbers of the deviation of the average employee score from the average specialization score in the diagram below corresponds to the colors of this scale.',
            },
          },
        },
        summaryScore: {
          title: "Summary matrix of team members' scores",
          description:
            '<p>The report is generated based on the last assessment 360 during the specified period.<br />The score is calculated as the arithmetic mean of the scores received from all participants in the assessment.</p>',
          table: {
            headers: {
              competence: 'Block/Competence',
              averageScore: 'Average score by specialization',
            },
            legendLabels: {
              scores: 'The scale of scores',
            },
            tooltips: {
              scoresLegend:
                'The color of the numbers in the tables corresponds to the scale. The values on the scale are the actual values of the scale ranges set at the date of the report generation.',
            },
          },
        },
        completeness: {
          title: 'Checking the completeness of the data',
          progress: {
            title: 'Respondent engagement',
            table: {
              headers: {
                team: 'Team name',
                member: 'Team member',
                progress: '% of assessment completion',
                estimated: 'Estimated',
              },
            },
          },
        },
        strengthsGrowth: {
          title: 'Strengths and growth areas',
          description:
            '<p>The score is calculated as the arithmetic mean of the scores of the selected participants.</p>',
          blocks: {
            strengths: {
              title: 'Strengths',
              description:
                '<p>The skills in which the selected participants demonstrate the highest results. They can become the basis for internal mentoring.</p>',
            },
            growthAreas: {
              title: 'Growth areas',
              description:
                '<p>Skills that require attention or additional support to perform tasks effectively, as well as potential development points that are critical for this specialization.</p>',
            },
          },
        },
        userRating: {
          title: 'Maximum and minimum values',
          description:
            '<p>Participants with the highest and lowest final scores for each competence.</p>',
          table: {
            headers: {
              competence: 'Блок/Компетенция',
              maxResult: 'Best result',
              minResult: 'Failed result',
            },
          },
        },
      },
    },
    personal: {
      score: {
        legend: {
          motivation: {
            max: 'Full match',
            normal: 'Match',
            min: 'Full mismatch',
          },
          factors: {
            max: 'Full match',
            normal: 'Match',
            min: 'Full mismatch',
          },
        },
        table: {
          headers: {
            indicator: 'Indicator',
            description: 'Description',
          },
        },
      },
      factors: {
        title: 'The block «Assessment of compliance with the profile of personal and stop factors»',
        descriptions: {
          team: '<p>A list of the main significant personal factors has been formed that must be evaluated by a team members when assembling a team and comparing candidates.</p><p>At the same time, several factors are stop factors - these are factors at certain values of which it is possible to predict significant risks for the effective work of the team.</p><p>Next, we will evaluate the personal factors for each participant in the assessment.</p>',
          user: '<p>A list of the main significant personal factors has been formed that must be evaluated by a team members when assembling a team and comparing candidates.</p>',
        },
        table: {
          titles: {
            team: 'Assessment of compliance with the profile of personal and stop factors of individual participants',
            user: 'Assessment of compliance with the profile of personal and stop factors',
          },
          descriptions: {
            team: '<p>Compliance with the profile of personal and stop factors will be assessed using colored markers and scores. Markers allow you to evaluate the qualitative compliance with the profile.</p><p>The scores allow you to assess the degree of compliance for comparing several evaluated:</p><ul><li>The maximum score for each motivation indicator is 4 points.</li><li>The maximum compliance with the profile is 32 points.</li></ul>',
            user: '<p>Compliance with the profile of personal and stop factors will be assessed using colored markers and scores. Markers allow you to evaluate the qualitative compliance with the profile.</p><ul><li>The maximum score for each motivation indicator is 4 points.</li><li>The maximum compliance with the profile is 32 points.</li></ul>',
          },
        },
      },
      motivation: {
        title: 'The block «Assessment of compliance with the motivation profile»',
        descriptions: {
          team: '<p>A motivation profile has been formed that reflects expectations for leading/significant work motives for a successful team member.</p><p>With respect to this profile, the degree of compliance will be assessed for each participant in the assessment and for all team assembly options.</p><p>It is expected that a team member should have at least one bright motive highlighted from the profile.</p>',
          user: '<p>A motivation profile has been formed that reflects expectations for leading/significant work motives for a successful team member.</p><p>It is expected that a team member should have at least one bright motive highlighted from the profile.</p>',
        },
        table: {
          titles: {
            team: 'Assessment of compliance with the motivation profile of individual participants',
            user: 'Assessment of compliance with the motivation profile',
          },
          descriptions: {
            team: '<p>Compliance with the motivation profile will be assessed using colored markers and scores. Markers allow you to evaluate the qualitative compliance with the profile.</p><p>The scores allow you to assess the degree of compliance for comparing several evaluated:</p><ul><li>The maximum score for each motivation indicator is 4 points.</li><li>The maximum compliance with the profile is 20 points.</li></ul>',
            user: '<p>Compliance with the motivation profile will be assessed using colored markers and scores. Markers allow you to evaluate the qualitative compliance with the profile.</p><ul><li>The maximum score for each motivation indicator is 4 points.</li><li>The maximum compliance with the profile is 20 points.</li></ul>',
          },
        },
      },
      summary: {
        titles: {
          team: 'Summary by the results of the assessment of the team',
          user: 'Summary by the results of the assessment',
        },
        factors: {
          title: 'Compliance with personal and stop factors',
          table: {
            headers: {
              userName: 'Name',
              risks: 'Risks based on personal factors',
            },
          },
          noData: 'There is nothing',
        },
        motivation: {
          title: 'Compliance by motivation',
          table: {
            headers: {
              userName: 'Name',
              risks: 'Risks based on motivation',
            },
          },
        },
      },
    },
  },
};
